// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Toastify__toast-container {\n  z-index: var(--toastify-z-index) !important;\n}\n\n.Toastify__close-button {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
